import type { ReactNode } from 'react'
import { ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import styles from '@/features/invitee/styles/invitesParity.module.css'
import configSortStyles from '@/components/listing/propertySortHeaderButton.module.css'

export interface UserTableSortIconProps {
  field: string
  orderBy?: string
  sortBy?: 'asc' | 'desc' | string
}

export interface UserTableSortColumnHeaderProps {
  field: string
  orderBy?: string
  sortBy?: 'asc' | 'desc' | string
  onSort: (column: string) => void
  children: ReactNode
  className?: string
  align?: 'start' | 'center' | 'end'
  disabled?: boolean
}

export function UserTableSortIcon({
  field,
  orderBy,
  sortBy,
}: UserTableSortIconProps) {
  const isActive = orderBy === field
  return (
    <span
      aria-hidden="true"
      className={cn(styles.sortIcon, isActive && styles.sortIconActive)}
    >
      {isActive ? (sortBy === 'asc' ? '▲' : '▼') : <ChevronsUpDown className="h-3 w-3" />}
    </span>
  )
}

export function UserTableSortColumnHeader({
  field,
  orderBy,
  sortBy,
  onSort,
  children,
  className = '',
  align = 'start',
  disabled = false,
}: UserTableSortColumnHeaderProps) {
  const handleSort = () => {
    if (disabled) return
    onSort(field)
  }
  return (
    <th
      data-testid={`um-table-sort-${field}`}
      className={cn(
        'select-none',
        disabled ? 'pointer-events-none cursor-default' : 'cursor-pointer',
        align === 'center' ? '!text-center' : '!text-left',
        className,
      )}
      onClick={handleSort}
    >
      <button
        type="button"
        disabled={disabled}
        className={cn(
          styles.sortHeaderButton,
          configSortStyles.propertySortHeaderButton,
          align === 'center' ? 'justify-center' : 'justify-start',
        )}
        onClick={(event) => {
          event.stopPropagation()
          handleSort()
        }}
      >
        <span className={styles.sortHeaderLabel}>{children}</span>
        <UserTableSortIcon field={field} orderBy={orderBy} sortBy={sortBy} />
      </button>
    </th>
  )
}


